import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { hasLinksInSelection } from 'wix-rich-content-common';
import InlineToolbarButton from './inlineButton';
import { openLinkModal } from './helpers';
var TextLinkButton = /** @class */ (function (_super) {
    tslib_1.__extends(TextLinkButton, _super);
    function TextLinkButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showLinkPanel = function () {
            var _a = _this.props, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState, theme = _a.theme, isMobile = _a.isMobile, helpers = _a.helpers, anchorTarget = _a.anchorTarget, relValue = _a.relValue, t = _a.t;
            openLinkModal(helpers, isMobile, anchorTarget, relValue, t, theme, getEditorState, setEditorState);
        };
        return _this;
    }
    Object.defineProperty(TextLinkButton.prototype, "isActive", {
        get: function () {
            return hasLinksInSelection(this.props.getEditorState());
        },
        enumerable: true,
        configurable: true
    });
    TextLinkButton.prototype.render = function () {
        var _a = this.props, theme = _a.theme, isMobile = _a.isMobile, t = _a.t, tabIndex = _a.tabIndex;
        var linkButtonTooltip = t('TextLinkButton_Tooltip');
        var buttonStyles = {
            button: theme.inlineToolbarButton,
            buttonWrapper: theme.inlineToolbarButton_wrapper,
            icon: theme.inlineToolbarButton_icon,
            active: theme.inlineToolbarButton_active,
        };
        return (React.createElement(InlineToolbarButton, { onClick: this.showLinkPanel, isActive: this.isActive, theme: tslib_1.__assign({}, theme, buttonStyles), isMobile: isMobile, tooltipText: linkButtonTooltip, tabIndex: tabIndex }));
    };
    TextLinkButton.propTypes = {
        getEditorState: PropTypes.func.isRequired,
        setEditorState: PropTypes.func.isRequired,
        onExtendContent: PropTypes.func.isRequired,
        onOverrideContent: PropTypes.func.isRequired,
        theme: PropTypes.object.isRequired,
        isMobile: PropTypes.bool,
        linkModal: PropTypes.bool,
        helpers: PropTypes.object,
        keyName: PropTypes.string,
        anchorTarget: PropTypes.string,
        relValue: PropTypes.string,
        t: PropTypes.func,
        tabIndex: PropTypes.number,
    };
    return TextLinkButton;
}(React.Component));
export default TextLinkButton;
//# sourceMappingURL=TextLinkButton.js.map